module.exports = __webpack_public_path__ + "img/hdp-2.9f6eb34d.jpeg";